import { Car } from '@hefe/models';
import { CarsSlice, ModalsSlice } from '@hefe/store';
import { t } from '@hefe/i18n';
import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';

interface AddEditCarFormProps {
  car?: Car;
}

export default function AddEditCarForm(props: AddEditCarFormProps) {
  const { car } = props;

  const dispatch = useAppDispatch();
  const modalState = useSelector(ModalsSlice.modalsState);

  const onSubmit = (values: any, resetForm: any) => {
    const closeModal = ModalsSlice.modalsActions.closeModal;
    const setModalLoading = ModalsSlice.modalsActions.setModalLoading;

    const action = car ? CarsSlice.updateCar : CarsSlice.createCar;

    dispatch(setModalLoading(true));
    dispatch(
      action({
        ...values,
        ...(car ? { id: car.id } : {}),
      })
    )
      .unwrap()
      .then(() => {
        dispatch(closeModal());
        resetForm();
      })
      .catch(() => null)
      .finally(() => dispatch(setModalLoading(false)));
  };

  return (
    <CustomForm
      key={`add-edit-car-form-${car ? car.id : 'new'}`}
      formId={`add-edit-car-form-${car ? car.id : 'new'}`}
      fields={[
        {
          name: 'licence_plate',
          label: t('cars.licence_plate'),
          type: 'text',
          initalValue: car?.licence_plate,
          rules: [
            {
              required: true,
              message: t('form_errors.name'),
            },
          ],
        },
        {
          name: 'manufacturer',
          label: t('manufacturer'),
          type: 'text',
          initalValue: car?.manufacturer,
          rules: [
            {
              required: true,
              message: t('form_errors.name'),
            },
          ],
        },
        {
          name: 'model',
          label: t('model'),
          type: 'text',
          initalValue: car?.model,
          rules: [
            {
              required: true,
              message: t('form_errors.name'),
            },
          ],
        },
        {
          name: 'color',
          label: t('color'),
          type: 'text',
          initalValue: car?.color,
          rules: [],
        },
        {
          name: 'seats',
          label: t('seats'),
          type: 'number',
          initalValue: car?.seats,
          rules: [
            {
              type: 'number',
              max: 99,
              message: t('form_errors.number_max', { max: 99 }),
            },
            {
              type: 'number',
              min: 1,
              message: t('form_errors.number_min', { min: 1 }),
            },
          ],
        },
        {
          name: 'fuel',
          label: t('cars.fuel'),
          type: 'text',
          initalValue: car?.fuel,
          rules: [],
        },
        {
          name: 'drivers_licence',
          label: t('cars.drivers_licence'),
          type: 'text',
          initalValue: car?.drivers_licence,
          rules: [],
        },
        {
          name: 'environment_badge',
          label: t('cars.environment_badge'),
          type: 'number',
          initalValue: car?.environment_badge,
          rules: [
            {
              type: 'number',
              max: 6,
              message: t('form_errors.number_max', { max: 6 }),
            },
            {
              type: 'number',
              min: 2,
              message: t('form_errors.number_min', { min: 2 }),
            },
          ],
        },
        {
          name: 'location',
          label: t('location'),
          type: 'text',
          initalValue: car?.location,
          rules: [],
        },
        {
          name: 'reservable',
          label: t('cars.reservable'),
          type: 'checkbox',
          initalValue: car?.reservable,
          rules: [],
        },
      ]}
      loading={modalState.modal.loading}
      onSubmit={onSubmit}
    />
  );
}
